import SiteMessagesInstance from '../../components/site-messages'
import sort from 'array-sort'
import lockIconBlack from '../../embeds/lock-icon-black'
import lockIconWhite from '../../embeds/lock-icon-white'

export class StepConnectedWifiSelect {
  constructor (onboarding) {
    this.onboarding = onboarding;

    this.lockIconBlack = lockIconBlack
    this.lockIconWhite = lockIconWhite

  }

  id = "connected_wifi_select";
  title = "Select WiFi Network";

  hide_wifi_password = false;
  selected_wifi_ssid = "";
  use_custom_wifi = false;
  is_first_wifi_load = true;

  // Remember WiFi (local)
  remembered_wifi = null;
  remember_applied = false;
  remember_prefilled = false;

  getRememberWifiTtlMs() {
    return (this.onboarding && this.onboarding.remember_wifi_ttl_ms)
      ? this.onboarding.remember_wifi_ttl_ms
      : (60 * 60 * 1000);
  }

  getRememberWifiStorageKey() {
    return (this.onboarding && this.onboarding.remember_wifi_storage_key)
      ? this.onboarding.remember_wifi_storage_key
      : 'tempstick_onboarding_wifi_v1';
  }

  canUseLocalStorage() {
    try {
      if (!window || !window.localStorage) {
        return false;
      }
      const k = '__ts_ls_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  readRememberedWifi() {
    if (!this.canUseLocalStorage()) {
      return null;
    }

    const key = this.getRememberWifiStorageKey();
    const now = Date.now();
    const ttl = this.getRememberWifiTtlMs();

    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) {
        return null;
      }

      const data = JSON.parse(raw);
      if (!data || !data.ssid) {
        window.localStorage.removeItem(key);
        return null;
      }

      let savedAt = (typeof data.saved_at === 'number') ? data.saved_at : 0;
      let expiresAt = (typeof data.expires_at === 'number') ? data.expires_at : 0;

      // Back-compat: if expires_at missing, derive it (and write back once)
      if (!expiresAt) {
        if (!savedAt) {
          savedAt = now;
        }
        expiresAt = savedAt + ttl;

        try {
          window.localStorage.setItem(key, JSON.stringify({
            ssid: String(data.ssid),
            password: (typeof data.password === 'string') ? data.password : '',
            saved_at: savedAt,
            expires_at: expiresAt
          }));
        } catch (e) {
          // ignore
        }
      }

      if (now >= expiresAt) {
        window.localStorage.removeItem(key);
        return null;
      }

      return {
        ssid: String(data.ssid),
        password: (typeof data.password === 'string') ? data.password : ''
      };
    } catch (e) {
      return null;
    }
  }

  sanitizeSsid(ssid) {
    return (ssid || '').replace(/&#39;/g, "'");
  }

  maybeApplyRememberedWifi() {
    if (this.remember_applied) {
      return;
    }

    if (!this.remembered_wifi || !this.remembered_wifi.ssid) {
      return;
    }

    const key = this.sanitizeSsid(this.remembered_wifi.ssid);

    // Don't override an intentional user selection
    if (this.selected_wifi_ssid && this.selected_wifi_ssid !== key) {
      return;
    }

    if (!this.wifi_networks[key]) {
      return;
    }

    this.selected_wifi_ssid = key;
    this.selectWifiNetwork(key);

    if (
      this.$wifiPassword &&
      this.$wifiPassword.val().length === 0 &&
      this.remembered_wifi.password
    ) {
      this.$wifiPassword.val(this.remembered_wifi.password);
      this.remember_prefilled = true;
    }

    this.remember_applied = true;
  }

  // Enterprise support
  is_v3_sensor = false;
  use_enterprise_wifi = false

  // Submit guard
  isSubmitting = false

  scroll_saved = 0;
  scroll_lock = false;

  template = `
  <div class="onboarding-step" data-for="connected_wifi_select">

    <form autocomplete="off" data-for="wifi-select">

      <div class="onboarding-wifi-select"></div>
      <div class="onboarding-wifi-select-loading">
        <img src="${window.site.home}/../assets/images/spinner-dots.svg" width="20" height="20" />
      </div>

      <div class="onboarding-wifi-select-use-custom-ssid">
        <div class="switch medium">
          <input class="switch-input" type="checkbox" id="wifi-custom-ssid" name="wifi-custom-ssid" value="1" />
          <label class="switch-paddle" for="wifi-custom-ssid">
            <span class="switch-active">Yes</span>
            <span class="switch-inactive"></span>
          </label>
        </div>
        <span for="wifi-custom-ssid">Use Hidden Network</span>
      </div>
      <div class="onboarding-wifi-custom-ssid">

        <label for="custom_ssid">Hidden WiFi Network Name:</label>

        <div class="onboarding-wifi-custom-ssid-input">
          <div class="onboarding-wifi-custom-ssid-input__input">
            <input type="text" id="custom_ssid" name="custom_ssid" data-for="custom_ssid" autocomplete="custom_ssid" aria-autocomplete="none" autocapitalize="off" />
          </div>
        </div>
      </div>

      <!-- Enterprise (802.1X) toggle: shown only for v3 sensors -->
      <div class="onboarding-wifi-enterprise-toggle" style="display:none;">
        <div class="switch medium">
          <input class="switch-input" type="checkbox" id="wifi-enterprise" name="wifi-enterprise" value="1" />
          <label class="switch-paddle" for="wifi-enterprise">
            <span class="switch-active">Yes</span>
            <span class="switch-inactive"></span>
          </label>
        </div>
        <label for="wifi-enterprise">My network requires a username and a password</label>
      </div>

      <div class="onboarding-wifi-enterprise" style="display:none;">
        <label for="enterprise_username">Username:</label>
        <div class="onboarding-wifi-enterprise-input">
          <div class="onboarding-wifi-enterprise-input__input">
            <input type="text" id="enterprise_username" name="enterprise_username" data-for="enterprise_username" autocomplete="username" aria-autocomplete="none" autocapitalize="off" />
          </div>
        </div>

        <div class="onboarding-wifi-password-note">(Enter only if your network requires a username, this is usually your work or school login.)</div>

      </div>

      <div class="onboarding-wifi-password">

        <label for="wifi_password">WiFi Password:</label>

        <div class="onboarding-wifi-password-input">
          <div class="onboarding-wifi-password-input__input">
            <input type="text" id="wifi_password" name="wifi_password" data-for="wifi_password" autocomplete="wifi-password" aria-autocomplete="none" autocapitalize="off" />
          </div>
          <div class="onboarding-wifi-password-input__password-toggle">
            <button type="button" class="onboarding-wifi-password-show-hide-password is-active" title="Show/Hide your password">
              <img data-for="eye_open" src="${window.site.home}/../assets/images/setup/icon-eye-open.svg" width="25" height="25" />
              <img data-for="eye_closed" src="${window.site.home}/../assets/images/setup/icon-eye-closed.svg" width="25" height="25" />
            </button>
          </div>
        </div>

        <div class="onboarding-wifi-password-note">(Leave blank if no password is required)</div>

      </div>

      <!-- Advanced options -->
      <div class="onboarding-wifi-advanced">
        <details>
          <summary>Advanced</summary>

          <div class="onboarding-wifi-auth-type">
            <label for="wifi_auth_type">WiFi Security Type:</label>
            <select id="wifi_auth_type" name="wifi_auth_type">
              <option value="AUTO" selected>Auto detect (recommended)</option>
              <option value="WIFI_AUTH_OPEN">Open (no password)</option>
              <option value="WIFI_AUTH_WPA2_PSK">WPA2 Personal (password only)</option>
              <option value="WIFI_AUTH_WPA_WPA2_PSK">WPA/WPA2 Mixed Personal</option>
              <option value="WIFI_AUTH_WPA2_ENTERPRISE">Enterprise (username + password)</option>
            </select>
            <div class="field-help">Complex WiFi networks may need this value manually changed, only change if Auto detect fails.</div>
          </div>

          <div class="onboarding-wifi-cert" style="display:none;">
            <label for="wifi_ca_cert">CA Certificate (PEM format):</label>
            <textarea id="wifi_ca_cert" name="wifi_ca_cert" rows="6" placeholder="-----BEGIN CERTIFICATE-----\\n...\\n-----END CERTIFICATE-----"></textarea>
            <div class="field-help">Paste your organization's certificate if required by your network.</div>
          </div>

        </details>
      </div>

      <button type="submit" class="button button--medium" data-for="temp_stick_connect_to_wifi" disabled>
        Connect Temp Stick to WiFi
      </button>

    </form>

  </div>
  `;

  onBack = () => {
    this.onboarding.goToStep(this.onboarding.stepBeforeWifiSelect());
  }

  onActivate = () => {

    console.log(this.onboarding.sensor);

    // clear the timeout for the sensor connection test
    clearTimeout(this.onboarding.connectedTimeout);

    // v3 detection: presence of sku means v3
    this.is_v3_sensor = !!(this.onboarding && this.onboarding.sensor && this.onboarding.sensor.sku);

    const sensorData = {};

    // send probe settings set during probe step during update
    if(this.onboarding.sensor && this.onboarding.sensor.hasTc && this.onboarding.sensor.hasTc === true) {
      if(this.onboarding.sensor.probe_enabled && this.onboarding.sensor.probe_enabled === true) {
        sensorData["TC_M"] = 1;
      } else {
        sensorData["TC_M"] = 0;
      }

      if(this.onboarding.sensor.probe_type) {
        sensorData["TC_TYPE"] = this.onboarding.sensor.probe_type;
      }

    }

    console.log({sensorData});

    this.onboarding.showBackButton();

    this.$wifiPassword.val('');

    this.remember_applied = false;
    this.remember_prefilled = false;
    this.remembered_wifi = this.readRememberedWifi();

    // Show enterprise controls only for v3 sensors
    if (this.is_v3_sensor) {
      this.$enterpriseToggleWrap.show();
    } else {
      this.$enterpriseToggleWrap.hide();
      this.$enterpriseWrap.hide();
    }

    if(!this.interval_get_wifi_networks) {

      this.Temp_Stick_Get_WiFi_Networks();

      this.interval_get_wifi_networks = setInterval(() => {
        this.Temp_Stick_Get_WiFi_Networks();
      }, 10000);

    }

  }

  bindActions = () => {
    this.$wifiForm = $(this.onboarding.container).find('form[data-for="wifi-select"]');
    this.$selectWifi = $(this.onboarding.container).find('.onboarding-wifi-select');
    this.$useCustomWifi = $(this.onboarding.container).find('.onboarding-wifi-custom-ssid');
    this.$useCustomWifiToggle = $(this.onboarding.container).find('#wifi-custom-ssid');
    this.$gettingWifiAnimation = $(this.onboarding.container).find('.onboarding-wifi-select-loading');

    this.$wifiPassword = $(this.onboarding.container).find('input[name="wifi_password"]');
    this.$wifiShowHidePassword = $(this.onboarding.container).find('.onboarding-wifi-password-show-hide-password');

    this.$connectBtn = $(this.onboarding.container).find('button[data-for="temp_stick_connect_to_wifi"]');

    // Enterprise refs
    this.$enterpriseToggleWrap = $(this.onboarding.container).find('.onboarding-wifi-enterprise-toggle');
    this.$enterpriseToggle = $(this.onboarding.container).find('#wifi-enterprise');
    this.$enterpriseWrap = $(this.onboarding.container).find('.onboarding-wifi-enterprise');
    this.$enterpriseUsername = $(this.onboarding.container).find('input[name="enterprise_username"]');

    // Advanced refs (also referenced inside the enterprise toggle below)
    this.$authTypeSelect = $(this.onboarding.container).find('#wifi_auth_type');
    this.$caCertField = $(this.onboarding.container).find('.onboarding-wifi-cert');
    this.$caCertTextarea = $(this.onboarding.container).find('textarea[name="wifi_ca_cert"]');

    this.$wifiForm.on('submit', async e => {
      e.preventDefault();

      if (this.isSubmitting) {
        return false;
      }

      const customWifi = this.$wifiForm[0].querySelector('[name="custom_ssid"]').value;
      const wifiPassword = this.$wifiForm[0].querySelector('[name="wifi_password"]').value;
      const enterpriseUsername = this.$wifiForm[0].querySelector('[name="enterprise_username"]')
        ? this.$wifiForm[0].querySelector('[name="enterprise_username"]').value
        : "";

      const authType = this.$authTypeSelect.val();
      let caCert = (this.$caCertTextarea.val() || "").trim();

      // Normalize literal "\n" into real line breaks
      caCert = caCert.replace(/\\n/g, "\n");

      // Also normalize Windows CRLF to LF
      caCert = caCert.replace(/\r\n/g, "\n");

      let error = "";
      let ssid = "";

      if (!this.use_custom_wifi) {
        if (!this.selected_wifi_ssid) {
          error = "Please select a WiFi network";
        } else {
          let network = this.wifi_networks[this.selected_wifi_ssid];

          if (network.password == 1 && wifiPassword.length === 0 && !this.use_enterprise_wifi) {
            error = "That WiFi network requires a password, please enter a password";
          }

          ssid = network.ssid;
        }
      } else {
        if (customWifi.length === 0) {
          error = "Please type in a hidden WiFi network name";
        }
        ssid = customWifi;
      }

      if (error.length === 0 && this.use_enterprise_wifi) {
        if (!enterpriseUsername || enterpriseUsername.trim().length === 0) {
          error = "Please enter an enterprise username";
        }
      }

      // If Enterprise cert field is visible, validate PEM markers when provided
      if (error.length === 0 && this.$caCertField.is(':visible') && caCert.length > 0) {

        const begins = caCert.startsWith('-----BEGIN CERTIFICATE-----');
        const ends = caCert.includes('-----END CERTIFICATE-----');
        if (!begins || !ends) {
          error = "Invalid certificate format. It must start with '-----BEGIN CERTIFICATE-----' and end with '-----END CERTIFICATE-----'.";
          this.$caCertTextarea.addClass('is-invalid');
        } else {
          this.$caCertTextarea.removeClass('is-invalid');
        }

      } else {
        this.$caCertTextarea.removeClass('is-invalid');
      }

      if (error.length > 0) {
        SiteMessagesInstance.addMessage("error", error);
        SiteMessagesInstance.displayMessages();
        return false;
      }

      this.isSubmitting = true;

      // ssid replace &#39; with '
      ssid = ssid.replace(/&#39;/g, "'");

      // Auto-remember for 1 hour
      this.onboarding.pending_remember_wifi = {
        ssid,
        password: (wifiPassword || "").trim(),
        saved_at: Date.now()
      };
      this.onboarding.commitRememberedWifi();

      const payload = {
        ssid: ssid
      };

      // Username/password rules
      if (this.use_enterprise_wifi) {
        payload.username = enterpriseUsername.trim();
        payload.password = (wifiPassword || "").trim();
      } else {
        // personal or auto
        if (authType !== 'WIFI_AUTH_OPEN') {
          payload.password = (wifiPassword || "").trim();
        }
      }

      // Auth override:
      // - If username toggle is ON, we intentionally keep AUTO (device infers enterprise by presence of username)
      // - Otherwise, include override only if user changed it from AUTO
      if (!this.use_enterprise_wifi && authType !== 'AUTO') {
        payload.auth_type = authType;
      }

      // CA cert if provided
      if (this.$caCertField.is(':visible') && caCert.length > 0) {
        payload.ca_cert = caCert;
      }

      this.onboarding.goToStep('connected_try_wifi');

      try {
        await this.onboarding.Temp_Stick_Request("POST", '/wlan', payload);
      } finally {
        this.isSubmitting = false;
      }
    });

    this.$selectWifi.on('click', '.onboarding-wifi-select__select', e => {
      this.selectWifiNetwork(e.currentTarget.dataset.ssid);
    });

    this.$wifiShowHidePassword.on('click', () => {
      this.hide_wifi_password = !this.hide_wifi_password;
      this.$wifiShowHidePassword.toggleClass('is-active', !this.hide_wifi_password);

      if (!this.hide_wifi_password) {
        this.$wifiPassword[0].type = 'text';
      } else {
        this.$wifiPassword[0].type = 'password';
      }
    });

    this.$useCustomWifiToggle.on('change', () => {
      this.use_custom_wifi = this.$useCustomWifiToggle.is(':checked');

      this.$useCustomWifi.toggleClass('is-active', this.use_custom_wifi);
      this.$selectWifi.toggleClass('is-disabled', this.use_custom_wifi);

      if (this.use_custom_wifi) {
        this.$connectBtn.prop('disabled', false);
      } else {
        this.$connectBtn.prop('disabled', !this.selected_wifi_ssid);
      }
    });

    // Enterprise toggle: controls visibility of enterprise fields AND the
    // advanced auth/cert UI. Single handler (previously bound twice).
    this.$enterpriseToggle.on('change', () => {
      this.use_enterprise_wifi = this.$enterpriseToggle.is(':checked');

      if (this.use_enterprise_wifi) {
        this.$enterpriseWrap.show();
        this.$authTypeSelect.prop('disabled', true);
        this.$authTypeSelect.val('WIFI_AUTH_WPA2_ENTERPRISE');
        this.$caCertField.show();
      } else {
        this.$enterpriseWrap.hide();
        this.$authTypeSelect.prop('disabled', false);
        if (this.$authTypeSelect.val() !== 'WIFI_AUTH_WPA2_ENTERPRISE') {
          this.$caCertField.hide();
        }
      }
    });

    // Handle manual auth_type selection
    this.$authTypeSelect.on('change', () => {
      const selected = this.$authTypeSelect.val();
      if (selected === 'WIFI_AUTH_WPA2_ENTERPRISE') {
        this.$caCertField.show();
      } else {
        this.$caCertField.hide();
      }
    });

  }

  selectWifiNetwork(ssid) {

    if (
      this.remember_prefilled &&
      this.remembered_wifi &&
      this.sanitizeSsid(this.remembered_wifi.ssid) !== ssid &&
      this.$wifiPassword
    ) {
      this.$wifiPassword.val('');
      this.remember_prefilled = false;
    }

    this.$selectWifi.find('.onboarding-wifi-select__select.is-active').removeClass('is-active');
    this.$selectWifi.find(`.onboarding-wifi-select__select[data-ssid="${ssid}"]`).addClass('is-active');

    this.$selectWifi.find('.onboarding-wifi-select__select__has-password').html(`
      <img src="${this.lockIconWhite}" width="20" height="20"/>
    `);

    this.selected_wifi_ssid = ssid;
    this.$connectBtn.prop('disabled', false);

  }

  interval_get_wifi_networks = null;
  wifi_networks = {};
  is_getting_wifi_networks = false;

  renderWifiNetworks() {

    let html = "";

    const networkIds = Object.keys(this.wifi_networks);
    let networks = [];

    networkIds.forEach(id => {
      networks.push(this.wifi_networks[id]);
    });

    networks = sort(networks, 'ssid');

    if(networks.length > 0) {
      networks.forEach(network => {
        html += `
        <button class="onboarding-wifi-select__select" type="button" data-ssid="${network.sanitized_ssid}">
          <div class="onboarding-wifi-select__select__text">
            ${network.ssid}
          </div>
          ${network.password == 1 ? `
          <div class="onboarding-wifi-select__select__has-password">
            <img src="${this.lockIconBlack}" width="20" height="20"/>
          </div>
          `: ""}
          
        </button>
        `
      })
    }

    this.$selectWifi.html(html);

    if(this.selected_wifi_ssid) {
      this.selectWifiNetwork(this.selected_wifi_ssid);
    }

  }

  onGetWifiNetworks(networks) {

    networks.forEach(network => {

      const sanitized_ssid = network.ssid.replace(/[^a-zA-Z0-9_\-]/g, '');
      network.sanitized_ssid = sanitized_ssid;

      this.wifi_networks[sanitized_ssid] = network;

    });

    // If we have saved WiFi, try to preselect it before render
    if (!this.selected_wifi_ssid && this.remembered_wifi && this.remembered_wifi.ssid) {
      const rememberedKey = this.sanitizeSsid(this.remembered_wifi.ssid);
      if (this.wifi_networks[rememberedKey]) {
        this.selected_wifi_ssid = rememberedKey;
      }
    }

    this.$gettingWifiAnimation.removeClass('is-active');

    this.renderWifiNetworks();

    // Prefill password only if SSID matched
    this.maybeApplyRememberedWifi();

  }

  getPasswordFieldTop() {
    const el = this.$wifiPassword[0];
    if (!el) {
      return 0;
    }

    // Distance from top of scrolling container
    const container = this.onboarding.container.querySelector('.onboarding-step');
    const rectField = el.getBoundingClientRect();
    const rectContainer = container.getBoundingClientRect();

    return rectField.top - rectContainer.top;
  }

  async Temp_Stick_Get_WiFi_Networks() {

    if(!this.onboarding.is_connected || this.is_getting_wifi_networks) {
      return;
    }

    // Capture password field's visual top BEFORE update so the periodic
    // re-render doesn't shift the page under the user.
    let beforeTop = this.$wifiPassword[0].getBoundingClientRect().top;
    let beforeScroll = window.scrollY;

    this.is_getting_wifi_networks = true;
    this.$gettingWifiAnimation.addClass('is-active');

    try {

      const networks = await this.onboarding.Temp_Stick_Request("GET", '/wirelessNetworks');
      this.is_getting_wifi_networks = false;

      this.onGetWifiNetworks(networks);

      // After rendering, measure again
      let afterTop = this.$wifiPassword[0].getBoundingClientRect().top;
      let afterScroll = window.scrollY;

      // Calculate how much to adjust scroll so the visual position stays fixed
      const delta = afterTop - beforeTop;
      window.scrollTo(0, beforeScroll + delta);

    } catch (e) {
      this.is_getting_wifi_networks = false;
    }

  }

}
